import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Popover } from '@material-ui/core';
import styles from './DropdownPopover.module.css';
import { useDropdownPosition } from 'hooks/useDropdownPosition';

const DropdownPopover = ({ open, setOpen, children, anchorEl, className }) => {
    const position = useDropdownPosition(open, anchorEl, 260, 20);

    const handleClose = () => {
        setOpen(false);
        anchorEl?.focus();
    };

    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={position.anchorOrigin}
            transformOrigin={position.transformOrigin}
            getContentAnchorEl={null}
            disableAutoFocus={true}
            disableEnforceFocus={true}
            disableRestoreFocus={true}
            marginThreshold={0}
            PaperProps={{
                style: {
                    width: anchorEl?.offsetWidth,
                    maxHeight: '260px',
                },
                elevation: 3,
                'data-position': position.anchorOrigin.vertical === 'bottom' ? 'below' : 'above',
            }}
            classes={{
                paper: cn(styles.dropdown, className),
            }}
            keepMounted={false}
        >
            {children}
        </Popover>
    );
};

DropdownPopover.propTypes = {
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    anchorEl: PropTypes.object,
    className: PropTypes.string,
};

export default DropdownPopover;
